var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('wrap',{staticClass:"gallery",attrs:{"title":"Bildergalerie"}},[_c('figure',{staticClass:"gallery-list",attrs:{"role":"group"}},_vm._l((_vm.images),function(image,idx){return _c('figure',{key:idx,staticClass:"gallery-item"},[_c('img',{attrs:{"src":image.urlOrig,"alt":image.title,"width":image.size[0],"height":image.size[1]}})])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-155ce61c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/blocks/Gallery.vue
// module id = null
// module chunks = 